/**
    商品列表
**/
<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家入驻申请</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="7">
        <div class="leftaside">
          <h4>商家入驻指南</h4>
          <div class="left_product">
            <el-menu
              default-active="6"
              class="el-menu-vertical-demo"
              :unique-opened='true'
              background-color="#f7f8f8"
            >
              <el-submenu index="0">
                <template slot="title">入驻流程</template>
                <el-menu-item index="0-1">商家提交申请</el-menu-item>
                <el-menu-item index="0-2">平台审核资质</el-menu-item>
                <el-menu-item index="0-3">商家缴纳费用</el-menu-item>
                <el-menu-item index="0-4">店铺开通</el-menu-item>
              </el-submenu>
             <el-menu-item index="2">
                <template slot="title"
                  >签订入驻协议</template
                >
              </el-menu-item>
              <el-menu-item index="3">
                <template slot="title"
                  >选择店铺类型</template
                >
              </el-menu-item>
              <el-menu-item index="4">
                <template slot="title"
                  >平台审核</template
                >
              </el-menu-item>
              <el-menu-item index="5">
                <template slot="title"
                  >合同签订及缴费</template
                >
              </el-menu-item>
              <el-menu-item index="6">
                <template slot="title"
                  >店铺开通</template
                >
              </el-menu-item>
            </el-menu>
          </div>
        </div>
        <div class="leftaside">
          <h4>平台联系方式</h4>
          <div class="left_product" style="padding: 20px">
            <p>电话：400-888-2816</p>
            <p>邮箱：sczx1@xunyou021.com</p>
          </div>
        </div>
      </el-col>
      <el-col :span="17" class="rightaside">
          <h3>店铺开通</h3>
          <el-divider></el-divider>
          <div class="textContent"><i class="el-icon-check orderSuccess_icon"></i> 店铺已为您开通！</div>
          <!-- <el-form :rules="rules" ref="sizeForm" :model="sizeForm" size="mini" class="nextPart">
            <el-form-item prop="checkedBox">
                <el-checkbox v-model="sizeForm.checkedBox">我已阅读并同意以上协议</el-checkbox>
                <span v-show="errerInfo" style="color:#78b942;margin-left:15px">请勾选 </span>
            </el-form-item>
             <el-form-item>
                <el-button class="nextButtom" type="primary" @click="nextEditResource('ruleForm')">下一步,填写资料</el-button>
            </el-form-item>
          </el-form> -->
          <!-- <div class="statusStep">
              <el-steps :space="200" :active="3" finish-status="success">
                <el-step title="已完成" description="签订入驻协议"></el-step>
                <el-step title="已完成" description="选择店铺类型"></el-step>
                <el-step title="进行中" description="平台审核"></el-step>
                <el-step title="未完成" description="合同签订及缴费"></el-step>
                <el-step title="未完成" description="店铺开通"></el-step>
            </el-steps>
          </div> -->
      </el-col>
    </el-row>
  </div>
</template>
<script>
// import { merchantpayMoney } from '@/api/xunyou'
export default {
  data() {
    return {
        isSuccess:true,
        
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
  },
};
</script>

<style scoped lang="less">
.breakcrumbHeader {
  margin: 15px 0;
}
.leftaside {
  width: 300px;
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  margin-right: 10px;
  margin-bottom: 40px;
  .el-submenu .el-menu-item {
    height: 25px;
    line-height: 25px;
  }
  /deep/.el-submenu__title,.el-menu-item {
    height: 40px;
    line-height: 40px;
  }
  /deep/.el-submenu__title:focus,
  /deep/.el-submenu__title:hover,
  /deep/.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow,
  /deep/.el-menu-item.is-active {
    color: #78b942;
  }  
}
.leftaside h4 {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size: 16px;
  font-weight: 700;
}

.rightaside{
    h3{
      font-size: 18px; 
      color: #333;
    }
    .textContent {
        font-size: 18px;
        text-align: center;
        margin: 100px;
    }
     .orderSuccess_icon{
        width: 70px;
        height: 70px;
        line-height: 70px;
        font-size: 30px;
        color: #83c44e;
        text-align: center;
        border: 2px solid #83c44e;
        border-radius: 42px;
        margin-right: 30px;
    }
 

}

</style>

 
 

 


// WEBPACK FOOTER //
// src/views/merchantSettled/storeOpen.vue